import { Button } from '@app/components/various/Button';
import { EmptyState } from '@app/components/various/EmptyState';
import { useTranslation } from 'react-i18next';

interface Props {
  onHideModal: () => void;
}

export const LookbookProductNotFoundContent = ({ onHideModal }: Props) => {
  const { t } = useTranslation(['products']);

  return (
    <EmptyState title={t('products:product_not_found_buyer')}>
      <Button color="secondary" variant="bordered" onClick={onHideModal}>
        {t('products:see_all_products')}
      </Button>
    </EmptyState>
  );
};
